module.exports = __webpack_public_path__ + "img/animation_640_lf1yjham.0ee88e71.gif";